import { memo } from 'react';

import { IcImage16Icon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import SelectedText from '../../SelectedText';
import styles from './styles.m.scss';

const Image = ({ message }) => {
  return (
    <>
      <IconView
        Icon={IcImage16Icon}
        size="small"
        className={styles.icon}
      />
      <SelectedText {...message.textChunk} />
    </>
  );
};

export default memo(Image);
